// extracted by mini-css-extract-plugin
export default {"checkboxPadding":"checkboxGroupWithContactDetails_checkboxPadding__UTqYi"};